import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';

/**
 * Rutas del módulo Mi Tablero. Se integran en `/private` desde `PrivateRoutes.ts`.
 *
 * La vista se carga con `useBrandComponent` y no con un `import()` directo, para
 * que una marca pueda sustituirla colocando su propio
 * `brand/src/modules/mi-tablero/views/MiTableroView.vue`.
 * (El módulo `tutorials` usa `import()` directo y por eso su vista no es
 * sobrescribible: ver `rediseno-tablero/CORE.md`.)
 *
 * Convive con la ruta actual `dashboard-main-2` hasta el switch de la fase 4.
 */
export const miTableroRoutes: RouteRecordRaw[] = [
    {
        path: 'mi-tablero',
        name: 'Mi Tablero v2',
        component: useBrandComponent('modules/mi-tablero/views/MiTableroView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Mi Tablero',
            /*
             * Mismo permiso y mismo nivel que la ruta anterior
             * (`dashboard-main-2`). Al pasar a ser el destino por defecto de
             * `/private` y del login (P4.1), tiene que filtrar igual que la que
             * sustituye: si no, un usuario sin `my_board` entraría a un tablero
             * al que antes no tenía acceso.
             */
            requiresPermission: 'brokerin',
            minLevel: 20,
            requiresSystemPermission: 'my_board'
        }
    }
];
